/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeocodingGeoJSONPropertiesAddendumOsm } from "./GeocodingGeoJSONPropertiesAddendumOsm";
import {
  GeocodingGeoJSONPropertiesAddendumOsmFromJSON,
  GeocodingGeoJSONPropertiesAddendumOsmFromJSONTyped,
  GeocodingGeoJSONPropertiesAddendumOsmToJSON,
  GeocodingGeoJSONPropertiesAddendumOsmToJSONTyped,
} from "./GeocodingGeoJSONPropertiesAddendumOsm";

/**
 * Optional additional information from the underlying data source (ex: OSM). This includes select fields. The most useful fields are mapped in the definition here, but others may be available.
 * @export
 * @interface GeocodingGeoJSONPropertiesAddendum
 */
export interface GeocodingGeoJSONPropertiesAddendum {
  [key: string]: any | any;
  /**
   *
   * @type {GeocodingGeoJSONPropertiesAddendumOsm}
   * @memberof GeocodingGeoJSONPropertiesAddendum
   */
  osm?: GeocodingGeoJSONPropertiesAddendumOsm;
}

/**
 * Check if a given object implements the GeocodingGeoJSONPropertiesAddendum interface.
 */
export function instanceOfGeocodingGeoJSONPropertiesAddendum(
  value: object,
): value is GeocodingGeoJSONPropertiesAddendum {
  return true;
}

export function GeocodingGeoJSONPropertiesAddendumFromJSON(
  json: any,
): GeocodingGeoJSONPropertiesAddendum {
  return GeocodingGeoJSONPropertiesAddendumFromJSONTyped(json, false);
}

export function GeocodingGeoJSONPropertiesAddendumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeocodingGeoJSONPropertiesAddendum {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    osm:
      json["osm"] == null
        ? undefined
        : GeocodingGeoJSONPropertiesAddendumOsmFromJSON(json["osm"]),
  };
}

export function GeocodingGeoJSONPropertiesAddendumToJSON(
  json: any,
): GeocodingGeoJSONPropertiesAddendum {
  return GeocodingGeoJSONPropertiesAddendumToJSONTyped(json, false);
}

export function GeocodingGeoJSONPropertiesAddendumToJSONTyped(
  value?: GeocodingGeoJSONPropertiesAddendum | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ...value,
    osm: GeocodingGeoJSONPropertiesAddendumOsmToJSON(value["osm"]),
  };
}
